import "./StatusBar.css";

export class StatusBar {
  constructor(state) {
    this.state = state;
    this.element = null;

    this.state.on("stateChanged", () => this.update());
  }

  getStatusIcon(status) {
    return status === "success" ? "😊" : "😞";
  }

  getStatusClass(status) {
    return status === "success" ? "sb-status-ok" : "sb-status-error";
  }

  handleStatusClick(sourceKey) {
    this.state.setCurrentPage(this.getPageFromSource(sourceKey));
  }

  getPageFromSource(sourceKey) {
    const pageMap = {
      configTiroirs: "config-tiroirs",
      baseROP: "base-rop",
      rapportFiberPvReussite: "rapport-fiber-pv-reussite",
      pvReussite: "pv-reussite",
      rapportFiberPvEchec: "rapport-fiber-pv-echec",
      pvEchec: "pv-echec",
    };
    return pageMap[sourceKey] || "config-tiroirs";
  }

  render() {
    const sources = this.state.getAllSources();

    const statusItems = Object.entries(sources)
      .map(([key, source]) => {
        const icon = this.getStatusIcon(source.status);
        const className = this.getStatusClass(source.status);
        const label = this.getSourceLabel(key);

        return `
        <div class="sb-status-item ${className}" data-source="${key}">
          <div class="sb-status-led">${icon}</div>
          ${label}
        </div>
      `;
      })
      .join("");

    return `
    <div class="sb-status-bar">
      ${statusItems}
    </div>
  `;
  }

  getSourceLabel(sourceKey) {
    const labels = {
      configTiroirs: {
        full: "[JSON] Configuration des Tiroirs",
        short: "[JSON] Config Tiroirs",
      },
      baseROP: {
        full: "[XLSX] Base ROP",
        short: "[XLSX] ROP",
      },
      rapportFiberPvReussite: {
        full: "[XLSX] Rapport FiberCable PV Réussite",
        short: "[XLSX] PV Réussite",
      },
      pvReussite: {
        full: "[SOR] Fichiers PV Réussite",
        short: "[SOR] PV OK",
      },
      rapportFiberPvEchec: {
        full: "[XLSX] Rapport FiberCable PV Échec",
        short: "[XLSX] PV Échec",
      },
      pvEchec: {
        full: "[SOR] Fichiers PV Échec",
        short: "[SOR] PV KO",
      },
      pvHs: {
        full: "[SOR] Fichiers PV Hors Service",
        short: "[SOR] PV HS",
      },
      conflictResolutions: {
        full: "Résolution Conflits",
        short: "Conflits",
      },
    };

    const labelObj = labels[sourceKey] || { full: sourceKey, short: sourceKey };

    // Retourner les deux versions dans le HTML
    return `
    <span class="label-full">${labelObj.full}</span>
    <span class="label-short">${labelObj.short}</span>
  `;
  }

  bindEvents() {
    if (!this.element) return;

    this.element.querySelectorAll(".sb-status-item").forEach((item) => {
      item.addEventListener("click", () => {
        const sourceKey = item.dataset.source;
        this.handleStatusClick(sourceKey);
      });
    });
  }

  update() {
    if (this.element) {
      this.element.innerHTML = this.render().match(/<div class="sb-status-bar">(.*)<\/div>/s)[1];
      this.bindEvents();
    }
  }

  mount(selector) {
    const container = document.querySelector(selector);
    if (!container) {
      throw new Error(`StatusBar container ${selector} not found`);
    }

    container.innerHTML = this.render();
    this.element = container.querySelector(".sb-status-bar");
    this.bindEvents();
  }

  unmount() {
    if (this.element) {
      this.element.remove();
      this.element = null;
    }
  }
}
